// extracted by mini-css-extract-plugin
export default {"wrap":"CurvedText_wrap__MHHy9","outer":"CurvedText_outer__w4kCq","inner":"CurvedText_inner__o5fWq","svg":"CurvedText_svg__UUi5O"};